// src/components/steps/Step2Form.js
import React, { useState, useEffect } from 'react';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import GeneralSettingsService  from '../../../../services/GeneralSettingsService';

// Mapping des clés d'API vers les noms d'affichage
const methodMapping = {
    'BANK': { name: "BANK", image: "assets/images/transfer-to-bank/bank1.svg" },
    'MTN_MOBILE_MONEY': { name: "MOBILE MONEY", image: "assets/images/transfer-to-bank/mtn.png" },
    'ORANGE_MONEY': { name: "Orange Money", image: "assets/images/transfer-to-bank/orange.png" },
    'WAVE': { name: "WAVE", image: "assets/images/transfer-to-bank/wave.png" }
};

const Step2Form = ({ formData, handleChange, onNext, onBack }) => {
    const [selectedMethod, setSelectedMethod] = useState(null);
    const [availableMethods, setAvailableMethods] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchWithdrawalMethods = async () => {
            try {
                setIsLoading(true);
                const response = await GeneralSettingsService.getAllParameters();

                if (response && response.length > 0) {
                    const settings = response[0];

                    // Trouver le taux correspondant au pays sélectionné
                    const countryRate = settings.paramRates.find(
                        rate => rate.country === formData.country
                    );

                    if (countryRate && countryRate.withDrawalMethods) {
                        // Convertir la chaîne de méthodes en tableau
                        const methodKeys = countryRate.withDrawalMethods.split(',');

                        // Mapper les clés aux méthodes complètes
                        const methods = methodKeys
                            .map(key => methodMapping[key.trim()])
                            .filter(method => method !== undefined); // Filtrer les méthodes non reconnues

                        setAvailableMethods(methods);
                    } else {
                        // Fallback si le pays n'est pas trouvé
                        setAvailableMethods([]);
                        setError(`Aucune méthode de retrait disponible pour ${formData.country}`);
                    }
                }
            } catch (err) {
                console.error('Erreur lors de la récupération des méthodes de retrait:', err);
                setError('Erreur lors du chargement des méthodes de retrait');
                setAvailableMethods([]);
            } finally {
                setIsLoading(false);
            }
        };

        if (formData.country) {
            fetchWithdrawalMethods();
        }
    }, [formData.country]);

    const handleMethodSelect = (method) => {
        setSelectedMethod(method);
        handleChange({ target: { name: 'withdrawalMethod', value: method } });
    };

    if (isLoading) {
        return (
            <div className="text-center p-4">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Chargement...</span>
                </div>
                <p className="mt-2">Chargement des méthodes de retrait...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger">
                <p>{error}</p>
                <Button variant="secondary" onClick={onBack}>
                    Retour
                </Button>
            </div>
        );
    }

    if (availableMethods.length === 0) {
        return (
            <div className="alert alert-warning">
                <p>Aucune méthode de retrait disponible pour {formData.country}.</p>
                <div className="mt-3 d-flex justify-content-between">
                    <Button variant="secondary" onClick={onBack}>
                        Retour
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <Form>
            <h2 style={{ paddingBottom: '32px' }}>
                Méthodes de retrait disponibles pour {formData.country}
            </h2>

            <div className="withdrawal-methods">
                {availableMethods.map((method, index) => (
                    <div
                        key={index}
                        className={`transfer-first ${selectedMethod === method.name ? 'selected' : ''}`}
                        onClick={() => handleMethodSelect(method.name)}
                        style={{ marginBottom: '10px' }}
                    >
                        <div className="bank-img">
                            <img src={method.image} alt={`${method.name}-icon`} />
                        </div>
                        <div className="bank-details">
                            <h2>{method.name}</h2>
                        </div>
                        <div className="bank-active-sec">
                            <Form.Check
                                type="radio"
                                name="withdrawalMethod"
                                id={`withdrawalMethod-${index}`}
                                checked={selectedMethod === method.name}
                                onChange={() => handleMethodSelect(method.name)}
                            />
                        </div>
                    </div>
                ))}
            </div>

            <div className="mt-3 d-flex justify-content-between">
                <Button variant="secondary" onClick={onBack}>
                    Retour
                </Button>
                <Button
                    variant="primary"
                    onClick={onNext}
                    disabled={!selectedMethod}
                >
                    Suivant
                </Button>
            </div>
        </Form>
    );
};

export default Step2Form;